<template>
    <div v-show="output" class="generatedHTML__CTA_Wrapper">
    <button class="panel__button save bg_white width_50" @click="handleSave">
        <svg class="fade-in" v-show="!saved" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3663 2C11.6556 2 11.9331 2.11493 12.1377 2.31952L13.6805 3.8623C13.8851 4.06689 14 4.34436 14 4.63369V12.3636C14 13.2674 13.2674 14 12.3636 14H3.63636C2.73263 14 2 13.2674 2 12.3636V3.63636C2 2.73263 2.73263 2 3.63636 2H11.3663ZM3.63636 3.09091C3.33512 3.09091 3.09091 3.33512 3.09091 3.63636V12.3636C3.09091 12.6649 3.33512 12.9091 3.63636 12.9091H4.18182V9.63636C4.18182 8.7326 4.91445 8 5.81818 8H10.1818C11.0856 8 11.8182 8.7326 11.8182 9.63636V12.9091H12.3636C12.6649 12.9091 12.9091 12.6649 12.9091 12.3636V5.17914C12.9091 4.88981 12.7942 4.61234 12.5896 4.40775L11.5923 3.41043C11.3877 3.20584 11.1102 3.09091 10.8209 3.09091H10.7273V4.18182C10.7273 5.08555 9.99467 5.81818 9.09091 5.81818H6.90909C6.00535 5.81818 5.27273 5.08555 5.27273 4.18182V3.09091H3.63636ZM10.7273 12.9091V9.63636C10.7273 9.33511 10.4831 9.09091 10.1818 9.09091H5.81818C5.51694 9.09091 5.27273 9.33511 5.27273 9.63636V12.9091H10.7273ZM6.36364 3.09091H9.63636V4.18182C9.63636 4.48306 9.39216 4.72727 9.09091 4.72727H6.90909C6.60785 4.72727 6.36364 4.48306 6.36364 4.18182V3.09091Z" fill="#041E3A"/>
        </svg>
        <svg class="fade-in" v-show="saved" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3.51953 8.32L6.50641 11.2L12.4795 5.44" stroke="#041E3A" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p v-show="!saved" class="fade-in">SAVE HISTORY</p>
        <p v-show="saved" class="fade-in">Saved</p>
    </button>
    <button class="copyCTA panel__button" @click="handleCopy">
      <svg v-show="copied" class="fade-in" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M3.51953 8.32L6.50641 11.2L12.4795 5.44" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-show="!copied" xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 9V1L9.5 0.5H3L2.5 1V3H0.5L0 3.5V11.5L0.5 12H7L7.5 11.5V9.5H9.5L10 9ZM7.5 8.5V3.5L7 3H3.5V1.5H9V8.5H7.5ZM1 4H6.5V11H1V4Z" fill="white"/>
    </svg>
      <p v-show="!copied" class="fade-in">Copy</p>
        <p v-show="copied" class="fade-in">Copied</p>
    </button>
   </div> 
    <div class="generatedHTML__wrapper">
      <p v-show="!output" class="placeholder">Add Ticker or Import Code to Start</p>
     <pre style="overflow: scroll;" v-show="output">
        <div id="output">{{output}}</div>
    </pre>

    </div>
</template>

<script setup>
import { output } from '@/helper/helper';
import { ref } from 'vue';
import {saveHTML} from '@/helper/helper'


const copied = ref(false)
const saved = ref(false)

const handleCopy = () => {
var copyText = document.getElementById("output");

navigator.clipboard.writeText(copyText.innerText);

copied.value = true

setTimeout(() => {
    copied.value = false
}, 1000)
}

const handleSave = () => {
    saveHTML()
    saved.value = true
  setTimeout(() => {
    saved.value = false
  }, 1000)
}
</script>

<style>

</style>